import useSWRInfinite from 'swr/infinite'
import { FetchResponse } from 'utils/fetcher'
import { ApiType } from 'utils/types'
import { encodePageQuery } from 'utils/pagination'
import { apiAuthFetcher } from 'api/goodtrust/api'
import { defineApiResource } from 'api/goodtrust/api/define'

export function useUserDeviceList() {
  return useSWRInfinite<FetchResponse<ApiType['PaginatedResponseUserDeviceResponse']>>(
    (_, prev) => encodePageQuery('/api/v1/user/device', prev),
    apiAuthFetcher
  )
}

export function useUserDeviceSharedWithList() {
  return useSWRInfinite<FetchResponse<ApiType['PaginatedResponseUserDeviceResponse']>>(
    (_, prev) => encodePageQuery('/api/v1/user/device/sharedWithMe', prev),
    apiAuthFetcher
  )
}

export const {
  use: useUserDevice,
  put: putUserDevice,
  delete: deleteUserDevice,
} = defineApiResource('/api/v1/user/device/{uuid}', {
  requiresAuth: true,
  parameters: ['uuid'],
})

export const { post: postUserDevice } = defineApiResource('/api/v1/user/device', {
  requiresAuth: true,
})

export const { put: putUserDeviceContact } = defineApiResource(
  '/api/v1/user/device/{uuid}/trusted-contact',
  {
    requiresAuth: true,
    parameters: ['uuid'],
  }
)
